/**
 * Get possible event target
 *
 * @param e {Event}
 * @return {*}
 */
const getEventTarget = e => {
  return e.target || e.currentTarget || e[0].target;
};

export {getEventTarget};
